const getGAEnvironment = () => {
  let hostname, env = ''
  if (typeof window !== 'undefined') {
    hostname = window.location.hostname
    if (hostname.search('grid-intake.enphaseenergy.com') >= 0) {
      env = 'production'
    } else if (hostname.search('grid-intake-preprod.enphaseenergy.com') >= 0) {
      env = 'production'
    } else if (hostname.search('grid-intake-stg.qa-enphaseenergy.com') >= 0) {
      env = 'qa2'
    } else if (hostname.search('grid-intake-rel.qa-enphaseenergy.com') >= 0) {
      env = 'rel'
    } else if (hostname.search('grid-intake-dev.qa-enphaseenergy.com') >= 0) {
      env = 'qa4'
    } else if (window.location.port === '8002') {
      env = 'qa4'
    } else {
      env = 'qa4'
    }
  } else if (env === 'test') {
    env = 'development'
  }
  return env
}

const pushToDataLayer = (props) => {
  window.dataLayer.push(props)
}

const USERBEHAVIOURTRACKING = 'userBehaviourTracking'

export { getGAEnvironment, pushToDataLayer, USERBEHAVIOURTRACKING }